import * as React from 'react';

import { useIntl } from 'bundles/page/lib/useIntl';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import { useDurationLabels } from 'bundles/unified-description-page-common/hooks/useDurationLabels';

import _t from 'i18n!nls/xdp';

type Props = {
  totalLearningMonths: number;
  learningHoursPerWeek: number;
  displayAsHeaderAndSubtitle?: boolean;
};

export const KeyInformationSpecializationDuration = ({
  totalLearningMonths,
  learningHoursPerWeek,
  displayAsHeaderAndSubtitle,
}: Props) => {
  const intl = useIntl();

  const labels = useDurationLabels(totalLearningMonths * 40, false);

  if (displayAsHeaderAndSubtitle) {
    return (
      <KeyInformationDetailsItem
        title={
          labels?.title ??
          intl.formatMessage(_t('{totalMonths} {totalMonths, plural, =1 {month} other {months}}'), {
            totalMonths: totalLearningMonths,
          })
        }
        subtitle={
          labels?.subtitle ??
          intl.formatMessage(_t('at {totalHours} {totalHours, plural, =1 {hour} other {hours}} a week'), {
            totalHours: learningHoursPerWeek,
          })
        }
      />
    );
  }

  return (
    <KeyInformationDetailsItem
      title={
        labels?.title ??
        intl.formatMessage(
          _t(
            '{totalMonths} {totalMonths, plural, =1 {month} other {months}} at {totalHours} {totalHours, plural, =1 {hour} other {hours}} a week'
          ),
          {
            totalMonths: totalLearningMonths,
            totalHours: learningHoursPerWeek,
          }
        )
      }
    />
  );
};

export default KeyInformationSpecializationDuration;
